// API
import { api } from '../configs/api/api';

// Models
import { INotificationItem } from '../interfaces/notifications.interfaces';

export const NotificationsService = {
  fetchNotificationsList: async (
    offset: number, limit: number = 20
  ): Promise<{
    notifications?: INotificationItem[],
    total?: number,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.get('/company/notifications', {
        params: {
          offset, limit
        }
      });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  markAsReadNotifications: async (): Promise<{
    message?: string,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.get('/workers/notifications/mark-read', );
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  notificationsUnreadCount: async (): Promise<{
    count?: number,
    message?: string,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.get('/workers/notifications/unread-count', );
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  deleteNotifications: async (
    notification_id?: number
  ): Promise<{ error?: string, message?: string, total?: number }> => {
    try {
      const axiosResponse = await api.delete('/company/delete-notifications', {
        params: {
          ...(notification_id && { notification_id })
        }
      });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500 || error?.response.status === 405) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
}
